<template>
  <div class="card card-user">
    <div class="image">
      <img :src="currentUser.position.department.company.banner_url" alt="...">
    </div>
    <div class="card-content">
      <div class="author">
        <img class="avatar border-white" :src="currentUser.avatar_url" alt="...">
        <h4 class="title"> {{ currentUser.name }}
          <br>
          <a href="#">
            <small>{{ currentUser.position.name }}</small>
          </a>
        </h4>
      </div>
      <p class="description text-center">
        <b class="seg">{{ currentUser.position.department.company.name }}</b>
      </p>
    </div>
    <hr>
    <div class="text-left info_colaborador">
      <div class="row">
        <div class="col-md-6">
          <h5> Data de Admissão
            <br>
            <small>{{ currentUser.admission_date | formatDateBr }}</small>
          </h5>
        </div>
        <div class="col-md-6">
          <h5> E-mail
            <br>
            <small>{{ currentUser.email }}</small>
          </h5>
        </div>
        <div class="col-md-6">
          <h5> Telefone
            <br>
            <small>{{ currentUser.phone }}</small>
          </h5>
        </div>
        <div class="col-md-6">
          <h5> Classificação Funcional
            <br>
            <small>{{ currentUser.position.functional_classification.name }}</small>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data () {
    return {

    }
  },
  filters: {
    formatDateBr (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  methods: {
    openForms () {
      window.open('https://forms.office.com/r/KCTMGsuk42', '_blank')
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    }
  }
}
</script>
<style scoped>
  .btn-danger-custom {
    background-color: red !important;
    color: white !important;
    border-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/UserCard.vue